export default function bgsetInit() {

  function debounce(func, wait = 300) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(this, args);
      }, wait);
    };
  }

  function bgset(target) {
    if (window.matchMedia("(min-width: 768px)").matches) {
      if (jQuery(target).data('bg-pc')) {
        let url = "url(" + jQuery(target).data('bg-pc') + ")";
        jQuery(target).css('background-image', url);
      }
    } else {
      if (jQuery(target).data('bg-sp')) {
        let url = "url(" + jQuery(target).data('bg-sp') + ")";
        jQuery(target).css('background-image', url);
      }
    }
  }

  // console.log(jQuery(".js__bg"));
  jQuery(window).on('load resize', function () {
    jQuery(".js__bg").each(function (i, e) {
      debounce(bgset(this), 500);
    })
  });

}